import { Injectable, inject } from '@angular/core';
import type { Observable } from 'rxjs';
import { BehaviorSubject, catchError, filter, shareReplay, switchMap, throwError } from 'rxjs';
import { NotificationService, Notification } from '@shared/notifications';
import type { MeteringPointDetails } from '../models';
import { MeteringPointResource } from './metering-point-api.service';

@Injectable({
  providedIn: 'root',
})
export class MeteringPointService {
  private readonly resource = inject(MeteringPointResource);
  private readonly notifications = inject(NotificationService);

  public unmapped$: Observable<MeteringPointDetails[]>;

  public unmappedBus = new BehaviorSubject<string>(undefined);

  public constructor() {
    this.subscribeToUnmapped();
  }

  public refresh(userUuid) {
    this.unmappedBus.next(userUuid);
  }

  private subscribeToUnmapped() {
    this.unmapped$ = this.unmappedBus.pipe(
      filter((userUuid) => !!userUuid),
      switchMap((userUuid) => this.resource.unmapped({ userUuid })),
      shareReplay(1),
      catchError((ex) => {
        this.handleLoadUnmappedMeteringPointsFailure();
        return throwError(ex);
      }),
    );
  }

  private handleLoadUnmappedMeteringPointsFailure() {
    this.notifications.show(
      Notification.toast().asWarning({
        messageKey: 'ROOMS_LOAD_ERROR',
      }),
    );
  }
}
